import React, { useContext } from 'react'
import { ChooseTreatmentContext } from '../CannaleoFreeDosageLayout';
import SettingsIcon from "../../../../icons/settings-icon.svg"
import { MainTracker } from '../../../../PixelTrackers/MainTracker'
import { useCustomer } from '../../../../customHooks/useCustomer'

type Props = {
    filtersCount?: number
}

const ProductFiltersControl: React.FC<Props> = ({ filtersCount }) => {

    const chooseTreatmentContext = useContext(ChooseTreatmentContext);
    const appliedFiltersCount = chooseTreatmentContext?.appliedFiltersCount || 0;
    const { customerState } = useCustomer();

    const handleFilterClick = () => {
        const isCurrentlyOpen = chooseTreatmentContext?.isFilterMenuOpen || false;
        const willBeOpen = !isCurrentlyOpen;
        
        // Track filter_click event when opening (fires once when opened)
        if (willBeOpen && !isCurrentlyOpen) {
            const userId = customerState?.customerID || null;
            MainTracker.track("custom", "filter_click", {
                user_id: userId,
                filter_popup_opened: true
            });
        }
        
        chooseTreatmentContext?.setIsFilterMenuOpen(willBeOpen);
    };

    return (
        <>
            {/* Filters Menu Trigger  */}
            <div
                id='filters-menu-trigger'
                className='w-[60px] h-[60px] rounded-md bg-primary-button-gradient flex items-center justify-center hover:opacity-85 ease cursor-pointer relative'
                onClick={handleFilterClick}>
                <img id='settings' src={SettingsIcon} className='w-[25px] h-[25px]' />
                <span id='filters-menu-count' className='absolute rounded-full w-[20px] h-[20px] flex justify-center items-center -right-1 -top-1 text-[#0A9281] font-medium p-[10px] bg-white'>
                    {appliedFiltersCount}
                </span>

            </div>

         
        </>

    )
}

export default ProductFiltersControl
